import { render, staticRenderFns } from "./FeedView_Duels.vue?vue&type=template&id=2eca7e2c&"
import script from "./FeedView_Duels.vue?vue&type=script&lang=js&"
export * from "./FeedView_Duels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports